import { render, staticRenderFns } from "./NewTreatmentPatientDetails.vue?vue&type=template&id=353a632e&scoped=true"
import script from "./NewTreatmentPatientDetails.vue?vue&type=script&lang=js"
export * from "./NewTreatmentPatientDetails.vue?vue&type=script&lang=js"
import style0 from "./NewTreatmentPatientDetails.vue?vue&type=style&index=0&id=353a632e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353a632e",
  null
  
)

export default component.exports